import {
  GET_OPPORTUNITY,
  CREATE_OPPORTUNITY,
  UPDATE_OPPORTUNITY,
  DELETE_OPPORTUNITY,
  CREATE_iNFORMATION,
  UPDATE_INFORMATION,
} from "./types";
import axios from "axios";

export const getOpportunity = () => async (dispatch) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_GOLANG_API}/api/v2/staking-opportunities`
    );

    return dispatch({
      type: GET_OPPORTUNITY,
      payload: response.data.opportunities,
    });
  } catch (error) {
    return error;
  }
};

export const createOpportunity = (payload) => async (dispatch) => {
  try {
    // Filter out any unexpected fields and ensure valid structure
    const { 
      createdAt, 
      updatedAt,
      ...dataToCreate 
    } = payload;
    
    const validPayload = {
      opportunityName: dataToCreate.opportunityName || "",
      coins: dataToCreate.coins || [],
      description: dataToCreate.description || "",
      longDescription: dataToCreate.longDescription || "", // Add longDescription field
      thumb: dataToCreate.thumbnail || dataToCreate.thumb || "", // Map thumbnail to thumb
      type: dataToCreate.type || "flutuante", // Default to "flutuante" if empty
      risk: dataToCreate.risk || "",
      yield: dataToCreate.yield || 0,
      contractAge: dataToCreate.contractAge || 0,
      currentTVL: (dataToCreate.currentTVL || 0) * 1000000, // Ensure proper TVL calculation
      allocation: dataToCreate.allocation || 0,
      playLink: dataToCreate.playLink || "",
      externalLink: dataToCreate.externalLink || "",
    };

    const response = await axios.post(
      `${process.env.REACT_APP_GOLANG_API}/api/v2/staking-opportunities`,
      validPayload
    );

    return dispatch({
      type: CREATE_OPPORTUNITY,
      payload: response.data.opportunity,
    });
  } catch (error) {
    return error;
  }
};

export const updateOpportunity = (payload) => async (dispatch) => {
  try {
    const { 
      id, 
      createdAt, 
      updatedAt,
      ...dataToUpdate 
    } = payload;
    
    // Filter to only include valid fields expected by the API
    const validPayload = {
      opportunityName: dataToUpdate.opportunityName,
      coins: dataToUpdate.coins || [],
      description: dataToUpdate.description || "",
      longDescription: dataToUpdate.longDescription || "", // Add longDescription field
      thumb: dataToUpdate.thumbnail || dataToUpdate.thumb || "", // Map thumbnail to thumb
      type: dataToUpdate.type || "flutuante", // Default to "flutuante" if empty
      risk: dataToUpdate.risk || "",
      yield: dataToUpdate.yield || 0,
      contractAge: dataToUpdate.contractAge || 0,
      currentTVL: (dataToUpdate.currentTVL || 0) * 1000000, // Fix TVL calculation
      allocation: dataToUpdate.allocation || 0,
      playLink: dataToUpdate.playLink || "",
      externalLink: dataToUpdate.externalLink || "",
    };
    
    const response = await axios.patch(
      `${process.env.REACT_APP_GOLANG_API}/api/v2/staking-opportunities/${id}`,
      validPayload
    );
    return dispatch({
      type: UPDATE_OPPORTUNITY,
      payload: response.data.opportunity,
    });
  } catch (error) {
    console.log("error", error);
    return error;
  }
};

export const deleteOpportunity = (id) => async (dispatch) => {
  try {
    await axios.delete(
      `${process.env.REACT_APP_GOLANG_API}/api/v2/staking-opportunities/${id}`
    );
    return dispatch({
      type: DELETE_OPPORTUNITY,
      payload: { id },
    });
  } catch (error) {
    return error;
  }
};

export const getInformation = () => async (dispatch) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_GOLANG_API}/api/v2/staking-information`
    );
    return dispatch({
      type: UPDATE_INFORMATION,
      payload: response.data.information,
    });
  } catch (error) {
    return error;
  }
};

export const createInformation = (payload) => async (dispatch) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_GOLANG_API}/api/v2/staking-information`,
      payload,
    );
    return dispatch({
      type: CREATE_iNFORMATION,
      payload: response.data.information,
    });
  } catch (error) {
    return error;
  }
};

export const updateInformation = (payload) => async (dispatch) => {
  try {
    const { id, ...dataToUpdate } = payload;
    
    // If we have an ID, update specific document, otherwise use upsert
    const url = id 
      ? `${process.env.REACT_APP_GOLANG_API}/api/v2/staking-information/${id}`
      : `${process.env.REACT_APP_GOLANG_API}/api/v2/staking-information`;
    
    const method = id ? 'patch' : 'put';
    
    const response = await axios[method](url, id ? dataToUpdate : payload);
    
    return dispatch({
      type: UPDATE_INFORMATION,
      payload: response.data.information,
    });
  } catch (error) {
    console.log("error", error);
    return error;
  }
};
